// extracted by mini-css-extract-plugin
export default {"spinner":"Transactions_spinner__w9q6W","table":"Transactions_table__okeH+","thead":"Transactions_thead__NmHeY","loader":"Transactions_loader__+ZoDy"};